import { render } from "./DropdownList.vue?vue&type=template&id=60b77831&ts=true"
import script from "./DropdownList.vue?vue&type=script&lang=ts"
export * from "./DropdownList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__